import { render } from "./LabelEdit.vue?vue&type=template&id=5d9cc562&scoped=true"
import script from "./LabelEdit.vue?vue&type=script&lang=js"
export * from "./LabelEdit.vue?vue&type=script&lang=js"

import "./LabelEdit.vue?vue&type=style&index=0&id=5d9cc562&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9cc562"]])

export default __exports__